import '../styles/sidebar.css';
import ProfilePicture from "../assets/images/marcos_picture.jpeg"
import LogOutIcon from "../assets/icons/log_out_icon.svg"
import ChatIcon from "../assets/icons/chat_icon.svg"
import AddIcon from "../assets/icons/add_icon.svg"
import {useContext, useEffect} from "react";
import {getUserChats} from "../services/ChatBotService";
import {HomeContext} from "../context/HomeContext";
import {useNavigate} from "react-router-dom";

// test
const Sidebar = () => {

    const navigate = useNavigate();
    const {setNewChat, selectedChat, chats, setChats} = useContext(HomeContext);

    useEffect(() => {
        getUserChats().then((response) => {
            setChats(response.data)
        })
    }, [setChats]);

    const handleChatOnClick = (chat_id) => {
        if (selectedChat !== chat_id) {
            setNewChat(false)
        }
        navigate(`/chat/${chat_id}`)
    }

    const handleNewChat = () => {
        setNewChat(true)
        navigate("/new-chat")
    }

    return (
        <div className={"sidebar"}>
            <div className="sidebar-container">
                <div className="profile">
                    <div className="icon">
                        <img src={ProfilePicture} alt=""/>
                    </div>
                    <div className="name-role">
                        <p className="name">
                            Marcos Carrera Herrero
                        </p>
                        <p className="role">
                            Blockchain
                        </p>
                    </div>
                </div>
                <div className="chats">
                    {
                        chats.map((chat, index) => {
                            return (
                                <div className="chat" key={index} onClick={() => handleChatOnClick(chat["id"])}>
                                    <div className="chat-container">
                                        <img src={ChatIcon} alt=""/>
                                        <p>{chat["title"]}</p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <div className="new-chat" onClick={handleNewChat}>
                    <div className="new-chat-container">
                        <div className="icon">
                            <img src={AddIcon} alt=""/>
                        </div>
                        <p>Start a new Chat</p>
                    </div>
                </div>
                <div className="bottom">
                    <div className="log-out">
                        <img src={LogOutIcon} alt=""/>
                        <p>Log out</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Sidebar;